import httpClient from '@/http-client'

export const get = (options = {}) => {
    return httpClient
        .get('/api/level-skill-subjects', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
    return httpClient
        .post('/api/level-skill-subjects', data)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
    return httpClient
        .delete(`/api/level-skill-subjects/${id}`)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
    return httpClient
        .get('/api/level-skill-subjects/form-view-models', options)
        .then(response => Promise.resolve(response.data))
        .catch(error => Promise.reject(error.response.data))
}
export default { get, store, formModel, destroy }
